import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IconButtonColors from './IconButtonColors';
import ClientProvider from './client';
export default createDemo(import.meta.url, IconButtonColors, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/buttons/demos/icon-colors/IconButtonColors.tsx",
    "fileName": "IconButtonColors.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Stack from '@mui/material/Stack';\nimport IconButton from '@mui/material/IconButton';\nimport Fingerprint from '@mui/icons-material/Fingerprint';\n\nexport default function IconButtonColors() {\n  return (\n    <Stack direction=\"row\" spacing={1}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <IconButton aria-label=\"fingerprint\" color=\"secondary\">\n        <Fingerprint />\n      </IconButton>\n      <IconButton aria-label=\"fingerprint\" color=\"success\">\n        <Fingerprint />\n      </IconButton>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 16,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Stack from '@mui/material/Stack';\nimport IconButton from '@mui/material/IconButton';\nimport Fingerprint from '@mui/icons-material/Fingerprint';\n\nexport default function IconButtonColors() {\n  return (\n    <Stack direction=\"row\" spacing={1}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <IconButton aria-label=\"fingerprint\" color=\"secondary\">\n        <Fingerprint />\n      </IconButton>\n      <IconButton aria-label=\"fingerprint\" color=\"success\">\n        <Fingerprint />\n      </IconButton>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fingerprint",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fingerprint"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fingerprint",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fingerprint"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 16,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "@mui/material/Stack",
      "@mui/material/IconButton",
      "@mui/icons-material/Fingerprint"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
